import { createReducer } from '@triumph/shared';

import {
  SET_INITIALISED,
  SET_DATA,
  SET_BASEPATH,
  SET_ERROR,
  SET_BASKET_ITEMS,
  SET_STEP,
  SET_FORM_VALUES,
  SET_LOADED_CONFIGURATION,
  SET_CATALOG_LIST,
  SET_PARTS_MODAL_PAGE,
  SET_PARTS_LIST,
  SET_HIGHLIGHTED_PART,
  SET_BIKE,
  SET_DELIVERY_METHOD,
  SET_SELECTED_DEALER,
  SET_GEOLOCATION,
  SET_BASKET_SUMMARY,
} from './types';

export const initialState = {
  initialised: false,
  data: {
    currency: 'GBP',
    disclaimers: {
      quantity: null,
      itemRrp: null,
      totalRrp: null,
    },
    ctas: {
      terms: null,
      privacyPolicy: null,
    },
    labels: {},
  },
  loading: true,
  basket: [],
  basketSummary: {
    totalPrice: 0,
    totalPriceLocalised: '',
  },
  bike: null,
  catalogList: null,
  partsModalPage: null,
  partsList: {},
  highlightedPart: null,
  step: 0,
  completedSteps: [],
  deliveryMethod: 1,
  geolocation: null,
  selectedDealer: null,
  form: {},
  configuration: null,
};

const appReducer = createReducer({
  initialState,
  reducers: {
    [SET_INITIALISED]: (state) => ({
      ...state,
      initialised: true,
      loading: false,
    }),
    [SET_DATA]: (state, { payload: data }) => ({
      ...state,
      data,
    }),
    [SET_BASEPATH]: (state, { payload }) => ({
      ...state,
      basepath: payload,
    }),
    [SET_ERROR]: (state, action) => ({
      ...state,
      error: action.payload,
    }),
    [SET_BASKET_ITEMS]: (state, { payload }) => ({
      ...state,
      basket: payload,
    }),
    [SET_BASKET_SUMMARY]: (state, { payload }) => ({
      ...state,
      basketSummary: payload,
    }),
    [SET_CATALOG_LIST]: (state, { payload: catalogList }) => ({
      ...state,
      catalogList,
    }),
    [SET_PARTS_MODAL_PAGE]: (state, { payload: partsModalPage }) => ({
      ...state,
      partsModalPage: partsModalPage === null ? undefined : partsModalPage,
    }),
    [SET_PARTS_LIST]: (state, { payload: partsList }) => ({
      ...state,
      partsList,
    }),
    [SET_HIGHLIGHTED_PART]: (state, { payload: highlightedPart }) => ({
      ...state,
      highlightedPart,
    }),
    [SET_BIKE]: (state, { payload: bike }) => ({
      ...state,
      bike,
    }),
    [SET_DELIVERY_METHOD]: (state, { payload: deliveryMethod }) => ({
      ...state,
      deliveryMethod,
    }),
    [SET_GEOLOCATION]: (state, { payload: geolocation }) => ({
      ...state,
      geolocation,
    }),
    [SET_SELECTED_DEALER]: (state, { payload: selectedDealer }) => ({
      ...state,
      selectedDealer,
    }),
    [SET_STEP]: (state, { payload: step }) => ({
      ...state,
      step,
      completedSteps: state.completedSteps.includes(step) ? state.completedSteps : [...state.completedSteps, step],
    }),
    [SET_FORM_VALUES]: (state, action) => ({
      ...state,
      form: {
        ...state.form,
        ...action.payload,
      },
    }),
    [SET_LOADED_CONFIGURATION]: (state, action) => ({
      ...state,
      configuration: action.payload,
    }),
  },
});

export default appReducer;
